import SlideFrame from "./_SlideFrame";

const items = [
  { n: "01", t: "New-lender onboarding", d: "Weeks for first integration; customization, payment-processor preferences, and licensing add time." },
  { n: "02", t: "New-loan boarding", d: "Daily, automated — once you're integrated, new loans flow in continuously." },
  { n: "03", t: "Payment processing (ACH + card)", d: "Modern rails with full reconciliation." },
  { n: "04", t: "Borrower servicing + account management", d: "AI-enhanced call center with human operators on the floor." },
  { n: "05", t: "Delinquency + collections workflows", d: "Plus integration with full-service 3rd-party collections consignment partners." },
];

export default function SlideWhatWeDo() {
  return (
    <SlideFrame tag="03 · The Product">
      <div className="grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <p className="overline mb-6">Servicing & Payment Infrastructure</p>
          <h2 className="font-display text-5xl md:text-6xl tracking-tighter leading-[0.95] font-medium">
            We power servicing <em className="italic">after</em> origination.
          </h2>
          <p className="mt-8 text-foreground/75 leading-relaxed">
            We don&rsquo;t deploy capital. We don&rsquo;t underwrite. We don&rsquo;t originate. We run the
            operating system that keeps your loans performing once they&rsquo;re funded.
          </p>
        </div>
        <div className="lg:col-span-7">
          <div className="border-t border-foreground/20">
            {items.map((i) => (
              <div key={i.n} className="grid grid-cols-12 gap-4 py-6 border-b border-foreground/20 items-baseline">
                <span className="col-span-1 font-mono-data text-xs text-muted-foreground">{i.n}</span>
                <span className="col-span-11 md:col-span-5 font-display text-2xl">{i.t}</span>
                <span className="hidden md:inline col-span-6 text-sm text-muted-foreground">{i.d}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </SlideFrame>
  );
}
